import { ExternalLink } from "lucide-react";
import { X_URL, SUBMIT_MEME_INTENT } from "../config";
import Reveal from "./Reveal";

export default function MemeContest() {
    return (
        <section data-testid="meme-contest-section" className="relative py-16 lg:py-24">
            <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-10">
                <Reveal>
                    <div
                        data-testid="meme-contest-card"
                        className="glass relative overflow-hidden rounded-3xl p-8 text-center md:p-14"
                    >
                        <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_20%_0%,rgba(168,85,247,0.14),transparent_55%),radial-gradient(circle_at_85%_100%,rgba(0,240,255,0.10),transparent_55%)]" />
                        <div className="relative">
                            <span className="kicker">MEME CONTEST</span>
                            <h2 className="headline mt-4 text-4xl text-white sm:text-5xl">MAKE THE INTERNET BALD</h2>
                            <p className="mx-auto mt-5 max-w-xl text-base md:text-lg text-slate-400">
                                Create the funniest $BALD meme.
                                <br />
                                Best memes can be featured on the official website and social channels.
                            </p>
                            <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
                                <a
                                    href={SUBMIT_MEME_INTENT}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    data-testid="meme-contest-submit-button"
                                    className="btn-primary w-full sm:w-auto"
                                >
                                    SUBMIT A MEME <ExternalLink className="h-4 w-4" />
                                </a>
                                <a
                                    href={X_URL}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    data-testid="meme-contest-join-community-button"
                                    className="btn-outline-purple w-full sm:w-auto"
                                >
                                    JOIN COMMUNITY
                                </a>
                            </div>
                        </div>
                    </div>
                </Reveal>
            </div>
        </section>
    );
}
